// This file was copied from site scanner. Planning to move it to ui-common.
import { JiraDescriptionIssue } from '@evinced-private/ui-common';

import { Report } from 'src/common/types/ReportModel';

import {
	JIRA_DESCRIPTION_PLATFORM,
	JiraDescriptionPlatform
} from '../../tickets-systems/TicketSystems.constants';

function buildIssueDesc(issue: Report, includePageUrl = false): JiraDescriptionIssue {
	return {
		kind: 'description',
		...(includePageUrl ? { pageUrl: issue.pageUrl } : {}),
		description: typeof issue.description === 'string' ? issue.description : undefined,
		elements: issue.elements,
		type: issue.type,
		summary: issue.summary,
		note: issue.note,
		screenshotUrl: issue.screenshotUrl,
		tags: issue.tags,
		severity: issue.severity?.id ? { id: issue.severity.id } : undefined
	};
}

export function formatIssueForExport(
	issue: Report,
	note?: string,
	type: JiraDescriptionPlatform = JIRA_DESCRIPTION_PLATFORM.WEB
): Report {
	const clonedIssue = structuredClone(issue);
	clonedIssue.note = note;
	clonedIssue.description =
		type === JIRA_DESCRIPTION_PLATFORM.WEB
			? buildIssueDesc(clonedIssue, true)
			: buildIssueDesc(clonedIssue);
	return clonedIssue;
}
